import { createAsyncThunk } from '@reduxjs/toolkit'

import { apiGET } from '../../lib/api'

export type DefectComment = {
  created: string
  ownComment: boolean
  comment: string
  crewType: string
}

export const fetchDefectCommentsByDefectIdAction = createAsyncThunk<
  DefectComment[],
  string,
  { rejectValue: { message: string } }
>('defectComments/fetchByDefectId', async (defectId, { rejectWithValue }) => {
  try {
    return await apiGET<DefectComment[]>(`/defectComments/${defectId}`)
  } catch (error: unknown) {
    console.error(`Failed to fetch comments for defect ID ${defectId}:`, error)
    return rejectWithValue({ message: 'Failed to fetch defect comments' })
  }
})
